import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular-ivy';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Sentry se inicializa antes que Angular para alcanzar a capturar los errores del arranque.
// El usuario logueado se publica aparte desde SentryService (login, recarga y cambios de compania/sede).
if (environment.sentry.enabled && environment.sentry.dsn) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.env,
    integrations: [
      // Version del BrowserTracing atada al Router de Angular. Requiere el TraceService que se
      // provee en AppModule, sin el no se generan las transacciones de navegacion.
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Es una aplicacion interna, se graba el texto para que el replay sirva de algo.
        // Se enmascara unicamente lo sensible: contrasenas y lo marcado con [data-sentry-mask].
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        mask: ['input[type="password"]', '[data-sentry-mask]'],
        // Cuerpos de las peticiones al API: sin esto el replay muestra que se hizo
        // una llamada, pero no que se envio ni que respondio SAP.
        networkDetailAllowUrls: [environment.apiUrl],
        // El login y el cambio de contrasena viajan con la clave en el cuerpo
        networkDetailDenyUrls: [/\/token(\?|$)/i, /api\/Passwords/i],
        networkCaptureBodies: true,
        // Authorization queda fuera a proposito: es el token de sesion del usuario
        networkRequestHeaders: ['Content-Type', 'cl-company-id', 'cl-headquarter-id', 'Cl-Request-Error-Description'],
        networkResponseHeaders: ['Content-Type']
      })
    ],
    // Adjunta la IP del usuario al evento, util para separar problemas de una sucursal
    sendDefaultPii: true,
    tracesSampleRate: environment.sentry.tracesSampleRate,
    replaysSessionSampleRate: environment.sentry.replaysSessionSampleRate,
    replaysOnErrorSampleRate: environment.sentry.replaysOnErrorSampleRate,
    // El API .NET no tiene Sentry, propagar sentry-trace/baggage no aportaria nada
    // y obligaria a que el CORS del API acepte esas cabeceras.
    tracePropagationTargets: []
  });
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
